import React from "react";

type PortableViewProps = {
  patientName: string;
  ndssNumber: string | null;
  lastEyeCheck: string;
};

const PortableView = ({
  patientName,
  ndssNumber,
  lastEyeCheck,
}: PortableViewProps) => {
  return (
    <div id="portable-view">
      <table>
        <tbody>
          <tr>
            <td>
              <div className="main">
                <div className="book-eye-check-logo">
                  <img
                    src="/images/portable-view-keepsight-white-on-blue.svg"
                    width="270"
                    alt="KeepSight logo"
                  />
                </div>

                <div className="header">Congratulations!</div>
                <div className="header-text">
                  You’ve taken the first step <br />
                  to keep an eye on your sight.
                </div>

                <p className="header-content-title">
                  <strong>
                    This is your KeepSight eye check visit information.
                  </strong>
                </p>

                <p className="header-content">
                  Take this with you when you go to your eye check appointment.
                  <br />
                  <br />
                  Your eye care provider will use information from this card to
                  record details of your eye check with KeepSight. This will
                  ensure you continue to receive reminders when you are next due
                  for an important eye check.
                </p>

                <hr />

                <div className="book-eye-check-patient-info">
                  <div className="title">
                    <strong>Information for eye care provider</strong>
                  </div>

                  <div id="book-eye-check-patient-name">
                    Name: <strong>{`${patientName}`}</strong>
                  </div>
                  {ndssNumber && (
                    <div id="book-eye-check-ndss">
                      NDSS number: <strong>{`${ndssNumber}`}</strong>
                    </div>
                  )}
                  <div id="book-eye-check-last-eye-check">
                    Last diabetic eye test: <strong>{`${lastEyeCheck}`}</strong>
                  </div>
                </div>

                <p>
                  I am registered with KeepSight, the national eye check recall
                  and reminder program for people with diabetes.
                </p>

                <p>
                  I am due for an eye check and would like my details to be
                  recorded on the KeepSight register to receive important eye
                  health information as well as reminders for when my next eye
                  checks are due.
                </p>

                <p>
                  To record this information, visit{" "}
                  <a href="www.keepsight.org.au">www.keepsight.org.au</a> or
                  enter it in the Oculo system.
                </p>

                <p>
                  <strong>Note:&nbsp;</strong>Eye care providers who don’t use
                  the Oculo system will also need to register as a KeepSight
                  provider via the website. Registration takes only a minute.
                  Have your AHPRA number handy.
                </p>

                <hr />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PortableView;
